import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import MainContainer from "../../components/MainContainer";
import { TicketInfo } from "../../components/TicketInfo";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { xReqId } from "../../utils";

export default function StatTicketPage() {
	const [payload, setPayload] = useState();
	const [canIseeTicketInfo, setCanIseeTicketInfo] = useState(false);
	const { register, formState, handleSubmit, watch } = useForm({
		mode: "all",
		defaultValues: {
			ticketCode: "",
			fullName: "",
			idNumber: "",
		},
	});

	const watchTicketCode = watch("ticketCode");

	useDocumentTitle("Στοιχεία εισιτηρίου");

	const submitTicket = async () => {
		// Build the URL for the API endpoint.
		const url = `/api/stats/ticket?code=${watchTicketCode.trim()}`;

		setCanIseeTicketInfo(true);
		try {
			// Send a POST request to the API endpoint with the ticket data.
			const res = await fetch(url, {
				method: "POST",
				credentials: "include", // Include cookies for authentication.
				headers: {
					"Content-Type": "application/json",
					"x-request-id": xReqId,
				},
			});

			// If the response is successful, navigate to the success page, otherwise go to catch and show the toast error.
			if (res.ok) {
				const responseData = await res.json();
				setPayload(responseData);
			} else {
				throw res;
			}
		} catch {
			toast.error("Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε αργότερα.");
		}
	};

	const isObjectEmpty = (obj) => {
		return Object.keys(obj).length === 0;
	};

	const hasErrors = !isObjectEmpty(formState.errors);
	const valuesIsEmptyObject = isObjectEmpty(watch());

	const disabledBtn = hasErrors || valuesIsEmptyObject || watchTicketCode?.trim() === "" || formState.isSubmitting;

	useEffect(() => {
		if (watchTicketCode !== undefined) {
			setCanIseeTicketInfo(false);
		}
	}, [watchTicketCode]);

	return (
		<MainContainer>
			<div className="col-lg-7">
				<h1 className="mb-4">Στοιχεία εισιτηρίου</h1>
				<form noValidate onSubmit={handleSubmit(submitTicket)}>
					<div className="mb-5">
						<label htmlFor="ticketCode" className="form-label">
							Κωδικός εισιτηρίου <span className="required">*</span>
						</label>
						<div className="d-flex flex-row gap-3">
							<input
								required
								id="ticketCode"
								onInput={(e) => {
									e.target.value = e.target.value.replace(/\D/g, "");
								}}
								aria-describedby="ticketCode-help"
								{...register("ticketCode", {
									maxLength: {
										value: 12,
									},
									minLength: {
										value: 12,
									},
									pattern: {
										value: /^\d{12}$/,
									},
								})}
								className={`form-control form-control-lg ${formState.errors.ticketCode ? "is-invalid" : ""}`}
							/>
							<button type="submit" disabled={disabledBtn} className="btn btn-primary btn-lg btn-login">
								{formState.isSubmitting ? (
									<div className="d-flex justify-content-center align-items-center">
										<RotatingLines
											visible={true}
											color="grey"
											strokeWidth="5"
											strokeColor="white"
											animationDuration="0.75"
											ariaLabel="rotating-lines-loading"
											wrapperStyle={{}}
											wrapperClass=""
										/>
										<div>Aποστολή</div>
									</div>
								) : (
									"Aποστολή"
								)}
							</button>
						</div>
						<div id="ticketCode-help" className={`form-text ${formState?.errors?.ticketCode ? "error text-danger" : " "}`}>
							12ψήφιος κωδικός
						</div>
					</div>
				</form>
				{canIseeTicketInfo && <TicketInfo isStats={true} {...payload} />}
			</div>
		</MainContainer>
	);
}
